import '../theme'
import App from './App.svelte'

new App({
    target: document.getElementById('app')!,
})

// eslint-disable-next-line @typescript-eslint/no-useless-empty-export
export { }
